"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMarketCookies = exports.isNonProd = exports.i18nConversionAppend = exports.globalizationPath = exports.getRootSubDomain = exports.getLocalizedDayjs = exports.currentLang = exports.currentCountry = exports.DEFAULT_MARKET = exports.DEFAULT_LANG = void 0;
var _queryString = _interopRequireDefault(require("query-string"));
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _dayjsPluginUtc = _interopRequireDefault(require("dayjs-plugin-utc"));
var _localeData = _interopRequireDefault(require("dayjs/plugin/localeData"));
var _localizedFormat = _interopRequireDefault(require("dayjs/plugin/localizedFormat"));
var _customParseFormat = _interopRequireDefault(require("dayjs/plugin/customParseFormat"));
const DEFAULT_MARKET = exports.DEFAULT_MARKET = 'usa';
const DEFAULT_LANG = exports.DEFAULT_LANG = 'en';
const INT_ENG_MARKET = 'int';
const MASK_MARKET_LIST = [DEFAULT_MARKET, INT_ENG_MARKET];
const COUNTRY_LANG_REGEX = /\/(?<country>[a-zA-Z]{3})\/(?<language>[a-zA-Z]{2})\//;
const cookies = new _universalCookie.default();
const isNonProd = () => {
  const nonProdHostPatterns = [/local\./, /localhost/, /www\.new/, /\.stage/, /\.test/, /\.dev/, /tst[\d]+\./, /dev[\d]+\./, /stg[\d]+\./, /-dev/, /-stage/, /-test/];
  for (let i = 0; i < nonProdHostPatterns.length; i += 1) {
    if (window.location.hostname.match(nonProdHostPatterns[i])) {
      return true;
    }
  }
  return false;
};
exports.isNonProd = isNonProd;
const getRootSubDomain = () => {
  const locOrigin = window.location.hostname;
  let locOriginMatch = locOrigin.match(/.*(\.[^.]+\.[^.]+\.com\.[^.]+)$/);
  if (locOriginMatch == null) {
    locOriginMatch = locOrigin.match(/.*(\.[^.]+\.com\.[^.]+)$/);
  }
  if (locOriginMatch == null) {
    locOriginMatch = locOrigin.match(/.*(\.[^.]+\.[^.]+\.[^.]+)$/);
  }
  if (locOriginMatch == null) {
    locOriginMatch = locOrigin.match(/.*(\.[^.]+\.[^.]+)$/);
  }
  if (locOriginMatch != null) {
    return locOriginMatch[1];
  }
  return locOrigin;
};

/**
 * Setting the country and language market cookies
 * country, language and wuc, wul (PROD/NON_PROD)
 * */
exports.getRootSubDomain = getRootSubDomain;
const setMarketCookies = _ref => {
  let {
    country,
    language
  } = _ref;
  const {
    hostname
  } = window.location;
  const isCelebrity = hostname.includes('celebritycruises') || hostname.includes('0.0.0.0');
  if (isCelebrity) {
    // Override Celebrity country cookies
    cookies.set('wuc', country, {
      path: '/',
      secure: false
    });
    cookies.set('country', country, {
      path: '/',
      secure: false
    });
  } else {
    const nonprod = isNonProd() ? '_nonprod' : '';
    const domain = getRootSubDomain();

    // Setting country cookies
    cookies.set("wuc".concat(nonprod), country, {
      path: '/',
      domain,
      secure: false
    });
    cookies.set('country', country, {
      path: '/',
      domain,
      secure: false
    });

    // Setting language cookies
    cookies.set("wul".concat(nonprod), language, {
      path: '/',
      domain,
      secure: false
    });
    cookies.set('language', language, {
      path: '/',
      domain,
      secure: false
    });
  }
  return cookies;
};

/**
 * Return the country by parameter, cookie or DEFAULT_COUNTRY
 * */
exports.setMarketCookies = setMarketCookies;
const currentCountry = function () {
  let skipPathnameCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  // Getting country from query
  const params = _queryString.default.parse(window.location.search);
  const countryCode = params.country || params.wuc;
  if (countryCode) {
    return countryCode.toLowerCase();
  }
  const nonprod = isNonProd() ? '_nonprod' : '';
  const cookieCountry = cookies.get('country') || cookies.get("wuc".concat(nonprod));
  if (cookieCountry && skipPathnameCheck) {
    return cookieCountry.toLowerCase();
  }

  // Getting country from pathname
  const pathName = window.location.pathname;
  const pathNameMatch = pathName.match(COUNTRY_LANG_REGEX);
  return pathNameMatch ? pathNameMatch.groups.country.toLowerCase() : DEFAULT_MARKET;
};

/**
 * Return language from cookie
 * */
exports.currentCountry = currentCountry;
const currentLang = () => {
  // Getting language from pathname
  const pathName = window.location.pathname;
  const pathNameMatch = pathName.match(COUNTRY_LANG_REGEX);
  if (pathNameMatch) {
    return pathNameMatch.groups.language.toLowerCase();
  }
  const nonprod = isNonProd() ? '_nonprod' : '';
  return cookies.get('language') || cookies.get("wul".concat(nonprod)) || DEFAULT_LANG;
};

/*
 * Returns true if path should be masked (only show default url - royalcaribbean.com/reservation/lookup)
 * */
exports.currentLang = currentLang;
const isMaskedPath = (market, lang) => {
  return MASK_MARKET_LIST.includes(market.toLowerCase()) && lang === DEFAULT_LANG;
};
const globalizationPath = (market, lang, subDomain, page) => {
  if (market) {
    return isMaskedPath(market, lang) ? subDomain : "/".concat(market, "/").concat(lang).concat(subDomain);
  }
  const pathName = window.location.pathname;
  if (pathName.match(/\/[a-z]{3}\/[a-z]{2}\//) != null) {
    return pathName.substring(0, pathName.lastIndexOf("/".concat(page)));
  }
  return subDomain;
};

/** Imports proper dayJS locale */
exports.globalizationPath = globalizationPath;
const getLocalizedDayjs = globalPayload => {
  let locale;
  try {
    locale = globalPayload.dayJSLangCode || globalPayload.language;
    // eslint-disable-next-line global-require
    require("dayjs/locale/".concat(locale, ".js"));
  } catch (error) {
    locale = 'en';
  }
  _dayjs.default.locale(locale);
  _dayjs.default.extend(_dayjsPluginUtc.default);
  _dayjs.default.extend(_localeData.default);
  _dayjs.default.extend(_localizedFormat.default);
  _dayjs.default.extend(_customParseFormat.default);
  return _dayjs.default;
};
exports.getLocalizedDayjs = getLocalizedDayjs;
const i18nConversionAppend = exports.i18nConversionAppend = {
  en_AU: {
    dayjsLocale: 'en-au',
    aemDictionary: 'en-au'
  },
  fr_CA: {
    dayjsLocale: 'fr-ca',
    aemDictionary: 'fr'
  }
};